/** 56 × 25 mm label at 203 dpi (447 × 200 dots). */
export const LABEL_56X25_203DPI = {
  id: "56x25" as const,
  widthIn: 2.2,
  heightIn: 0.98,
  dpi: 203,
  widthDots: 447,
  heightDots: 200,
  margin: 8,
  label: "56 × 25 mm",
  recommendedUse: "Small parts",
} as const;
